<div class="tooltip" [class.tooltip-top]="position === 'top'"
     [style.left]="left + 'px'" [style.top]="top + 'px'">
  {{tooltip}}
</div>
